<template>
  <ButtonTemplateMicInput
    :hint-box-text="domain === 'SELF_SERVICE' ? t('title_guide') : ''"
    :on-click="togglePopupSetting"
    :set-ref-button="(el) => (settingsMenuButton = el)"
    :text-button="t('setting')"
    :is-open="isVisiblePopupSetting"
  >
    <template #icon-handler>
      <component :is="IconEllipsis" class="icon-setting" :class="{ active: isVisiblePopupSetting }" />
    </template>
  </ButtonTemplateMicInput>

  <Teleport to="body">
    <DropdownBottom v-if="isVisiblePopupSetting" :target-el="settingsMenuButton" @close="setCurrentPopupMicInput">
      <ChatSetting :options="options" @toggleSettingModal="setCurrentPopupMicInput('')" />
    </DropdownBottom>
  </Teleport>
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import ButtonTemplateMicInput from '@/components/domains/chat/common/ButtonTemplateMicInput.vue';
import ChatSetting from '@/components/domains/chat/common/ChatSetting.vue';
import IconEllipsis from '@/components/icons/IconEllipsis.vue';
import DropdownBottom from '@/components/shared/base/DropdownBottom.vue';
import { TypeCall, TypeDomain } from '@/types/common';
import { ChatSettingOptions } from '@/types/components';
import { CHAT_SETTING_OPTIONS } from '@/utils/constants/chat';
import { ij_currentPopupMicInput, ij_setCurrentPopupMicInput } from '@/utils/injectionKeys';

const props = withDefaults(
  defineProps<{
    typeCall?: TypeCall;
    domain?: TypeDomain;
  }>(),
  {
    typeCall: 'GENERAL',
    domain: 'CHAT',
  }
);

const { t } = useI18n();

const settingsMenuButton = ref<HTMLElement>();

const currentPopupMicInput = inject(ij_currentPopupMicInput, ref(''));
const setCurrentPopupMicInput = inject(ij_setCurrentPopupMicInput, (popupName: string) => {});

const options = computed<ChatSettingOptions[]>(() => {
  const result = CHAT_SETTING_OPTIONS[props.typeCall] ?? [];

  if (props.domain === 'CHAT') {
    return [...result, 'DARK_MODE'];
  }

  return result;
});

const isVisiblePopupSetting = computed(() => currentPopupMicInput.value === 'setting');

const togglePopupSetting = () => {
  setCurrentPopupMicInput('setting');
};
</script>

<style scoped lang="scss"></style>
